import { useEffect, useState } from 'react';

import { getUserAuthProfile } from '../services/individualBioService';
import { UserAuthProfile } from '../types';

export const useUserAuthProfile = (userId?: string | null) => {
  const [userProfile, setUserProfile] = useState<UserAuthProfile | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!userId) return;
    setLoading(true);
    getUserAuthProfile(userId)
      .then(setUserProfile)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [userId]);

  return { userProfile, loading, error };
};
